export const VIDEO_TYPE = {
	RELIEF: 'RELIEF',
	STRENGTH: 'STRENGTH',
};
